"use client";

import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { format } from 'date-fns';

interface ChatMessageProps {
  message: {
    id: string;
    content: string;
    sender_id: string;
    sender_name: string;
    timestamp: string;
  };
  isOwn: boolean;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message, isOwn }) => {
  return (
    <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-xs lg:max-w-md px-4 py-2 rounded-2xl ${isOwn ? 'bg-primary text-primary-foreground' : 'bg-muted'}`}>
        <div className="flex items-start space-x-3">
          {!isOwn && (
            <Avatar className="h-8 w-8 flex-shrink-0 mt-1">
              <AvatarFallback className="bg-primary text-primary-foreground">
                {message.sender_name?.[0] || '?'}
              </AvatarFallback>
            </Avatar>
          )}
          <div className="flex-1 min-w-0">
            <div className="flex items-baseline space-x-2 mb-1">
              <span className="font-medium text-sm">{message.sender_name}</span>
              <span className="text-xs text-muted-foreground">
                {format(new Date(message.timestamp), 'HH:mm')}
              </span>
            </div>
            <p className={`text-sm ${isOwn ? 'text-primary-foreground' : ''}`}>
              {message.content}
            </p>
          </div>
          {isOwn && (
            <Avatar className="h-8 w-8 flex-shrink-0 mt-1 ml-2">
              <AvatarFallback className="bg-primary text-primary-foreground">
                {message.sender_name?.[0] || '?'}
              </AvatarFallback>
            </Avatar>
          )}
        </div>
      </div>
    </div>
  );
};